export enum InsuranceStatus {
  ACTIVE = 'IKR',
  UNDER_CHANGE = 'SÆN',
  UNDER_CANCELLATION = 'SIA',
  UNDER_ACTIVATION = 'SIK',
  CANCELLED = 'AFG',
  HIDDEN_CASE = 'SAG',
}
